import { render, staticRenderFns } from "./salesReturnsEdit_v4.vue?vue&type=template&id=14b82560&scoped=true&"
import script from "./salesReturnsEdit_v4.vue?vue&type=script&lang=js&"
export * from "./salesReturnsEdit_v4.vue?vue&type=script&lang=js&"
import style0 from "./salesReturnsEdit_v4.vue?vue&type=style&index=0&id=14b82560&lang=less&scoped=true&"
import style1 from "./salesReturnsEdit_v4.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b82560",
  null
  
)

component.options.__file = "salesReturnsEdit_v4.vue"
export default component.exports